import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { Body5, Container, Page, SVG_LOADING_ICON_TYPES, SvgLoadingIcon } from '@ui';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { updateCurrentUser } from '@services/user';
import { ROUTES } from '@constants/routes';
import { TrackingEvent } from '@classes/TrackingEvent';
import { useColorTheme } from '@hooks';

const PageWrapper = styled.div``;
const BodyWrapper = styled.div`
  padding: 24px;
`;

function ClosedBeta() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const colorTheme = useColorTheme();

  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const init = async () => {
      const { ok } = await updateCurrentUser({ user: { has_digital_analyst_access: true } })(dispatch);
      if (ok) {
        TrackingEvent.create('Set User With AI Access');
        setTimeout(() => {
          navigate(ROUTES.home);
        }, 2000);
      } else {
        TrackingEvent.create('Set User With AI Access Failed');
        setError(true);
      }
    };
    init();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <BodyWrapper>
          <Page>
            <Container>
              <h3>Digital Analyst</h3>
            </Container>
            <Container top={48} centerAll bottom={99}>
              <SvgLoadingIcon type={SVG_LOADING_ICON_TYPES.bars} color={colorTheme.text} />
              <Container left={8}>
                <Body5>Loading...</Body5>
              </Container>
            </Container>
          </Page>
        </BodyWrapper>
      </Body>
    </PageWrapper>
  );
}

export default ClosedBeta;
